import { TemplateRef } from "@angular/core";

export enum ColumnType {
  String = 'string',
  Number = 'number'
}

export interface TableConfig {
  enablePagination?: boolean;
  enableSort?: boolean;
  enableSearch?: boolean;  // Changed from enableFilter
  enableFilter?: boolean;  // Changed from showFilterButton
  enableCSVDownload?: boolean;
  enableExcelDownload?: boolean;
  showSerialNumber?: boolean;
  stickyHeader?: boolean;
  pageSize?: number;
  pageSizeOptions?: number[];
}

export interface TableColumn {
  key: string;
  header: string;
  sortable?: boolean;
  type?: ColumnType;
  filterable?: boolean;
  template?: TemplateRef<any>;
  sticky?: boolean;
  styleClass?: string; // Add this optional property
}